// Waypoints for the warren dragon mark when it has roamed since the last
// overview visit. Chamber-local dragon anchors are already absolute in the
// payload; passages run at cy + 8 between the drawn door lips (±46 from cx).

export const PASSAGE_OFFSET_X = 46
export const PASSAGE_OFFSET_Y = 8

export function dragonAbsolute(chamber) {
  return { x: chamber.cx + chamber.dragon.x, y: chamber.cy + chamber.dragon.y }
}

export function passagePoint(chamber, side) {
  const x = side === "exitRight" ? chamber.cx + PASSAGE_OFFSET_X
    : side === "exitLeft" ? chamber.cx - PASSAGE_OFFSET_X
    : side === "enterRight" ? chamber.cx + PASSAGE_OFFSET_X
    : chamber.cx - PASSAGE_OFFSET_X

  return { x, y: chamber.cy + PASSAGE_OFFSET_Y }
}

// Anchor → door lip → passage mid → next door lip → … → anchor.
export function roamWaypoints(chambers, fromIndex, toIndex) {
  if (fromIndex === toIndex) return [ dragonAbsolute(chambers[fromIndex]) ]

  const points = [ dragonAbsolute(chambers[fromIndex]) ]
  const step = fromIndex < toIndex ? 1 : -1
  let index = fromIndex

  while (index !== toIndex) {
    const next = index + step
    const current = chambers[index]
    const upcoming = chambers[next]

    if (step > 0) {
      points.push(passagePoint(current, "exitRight"))
      const left = current.cx + PASSAGE_OFFSET_X
      const right = upcoming.cx - PASSAGE_OFFSET_X
      points.push({ x: (left + right) / 2, y: current.cy + PASSAGE_OFFSET_Y })
      points.push(passagePoint(upcoming, "enterLeft"))
    } else {
      points.push(passagePoint(current, "exitLeft"))
      const left = upcoming.cx + PASSAGE_OFFSET_X
      const right = current.cx - PASSAGE_OFFSET_X
      points.push({ x: (left + right) / 2, y: current.cy + PASSAGE_OFFSET_Y })
      points.push(passagePoint(upcoming, "enterRight"))
    }

    index = next
  }

  points.push(dragonAbsolute(chambers[toIndex]))
  return points
}

export function easeInOut(t) {
  return t * t * (3 - 2 * t)
}

export function pointAlongWaypoints(waypoints, t) {
  if (waypoints.length === 1) return { ...waypoints[0] }

  const segments = []
  let total = 0

  for (let i = 0; i < waypoints.length - 1; i++) {
    const dx = waypoints[i + 1].x - waypoints[i].x
    const dy = waypoints[i + 1].y - waypoints[i].y
    const length = Math.hypot(dx, dy)
    segments.push(length)
    total += length
  }

  if (total === 0) return { ...waypoints[waypoints.length - 1] }

  const target = t * total
  let walked = 0

  for (let i = 0; i < segments.length; i++) {
    if (walked + segments[i] >= target) {
      const segT = (target - walked) / segments[i]
      return {
        x: waypoints[i].x + ((waypoints[i + 1].x - waypoints[i].x) * segT),
        y: waypoints[i].y + ((waypoints[i + 1].y - waypoints[i].y) * segT)
      }
    }
    walked += segments[i]
  }

  return { ...waypoints[waypoints.length - 1] }
}

export const ROAM_DURATION_MS = 2800

export function shouldRoam(lastRoom, dragonRoom, reducedMotion) {
  return lastRoom !== null && lastRoom !== dragonRoom && !reducedMotion
}
